import { CommonAxiosGet, CommonAxiosPost } from "./CommonAxios";
import { store } from "../store";
import { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { config } from "./CommonURLS";



export function getSecretraitDetailsList() {
  CommonAxiosGet(`getsecretratedetails`).then((res) => {
    store.dispatch({
      type: "SECRETARIATLIST",
      payload: res?.data?.SecretraitDetails,
    });
  });
}

export function getVillagesDetailsList(sec_id) {
  CommonAxiosGet(`getvillagedetails/${sec_id}`).then((res) => {
    console.log("villageres", res?.data);
    store.dispatch({ type: "VILLAGELIST", payload: res?.data?.VillageDetails });
  });
}

export function getRunningFinYear() {
  CommonAxiosGet(`getRunningFinYear`).then((res) => {
    store.dispatch({
      type: "RUNNINGFINYEAR",
      payload: res?.data?.data[0]?.acdyr,
    });
  });
}

export function getOutsideRunningFinYear() {
  axios.get(config.url.API_URL + `loginpayment/getRunningFinYear`).then((res) => {
    store.dispatch({
      type: "RUNNINGFINYEAR",
      payload: res?.data?.data[0]?.acdyr,
    });
  });
}

export function getRebateDetails() {
  CommonAxiosGet(`getRebuteDate`).then((res) => {
    store.dispatch({
      type: "REBATEDETAILS",
      payload: res?.data?.data[0],
    });
  });
}

export function getCurrentYearList() {
  CommonAxiosGet(`loginpayment/getCurrentFinyear`).then((res) => {
    store.dispatch({
      type: "CURRENTYEAR",
      payload: res?.data?.currentFinyearData,
    });
  });
}

export function getVillagesDetailsListVerify(sec_id) {
  CommonAxiosGet(`panchayatProfile/getVillages/${sec_id}`).then((res) => {
    store.dispatch({
      type: "VILLAGELISTVERIFY",
      payload: res?.data?.villageListVerify,
    });
  });
}

export function getPopulatedDetails(sec_id) {
  CommonAxiosGet(`panchayatProfile/getPopulatedDetails/${sec_id}`).then(
    (res) => {
      store.dispatch({
        type: "POPULATEDDETAILS",
        payload: res?.data?.getPopulatedDetails,
      });
    }
  );
}

export function getRevenueVillageData(sec_id) {
  CommonAxiosGet(`panchayatProfile/getVillages/${sec_id}`).then((res) => {
    store.dispatch({
      type: "REVENUEVILLAGEDATA",
      payload: res?.data?.villageListVerify,
    });
  });
}

export function getHabitationData(sec_id) {
  CommonAxiosGet(`panchayatProfile/getHabitation/${sec_id}`).then((res) => {
    store.dispatch({
      type: "HABITATIONDATA",
      payload: res?.data?.habitationList,
    });
  });
}

export function getBaiscInformationData(sec_id) {
  CommonAxiosGet(`/panchayatProfile/getBasicInfo/${sec_id}`).then((res) => {
    if (res?.data?.scode == "01") {
      store.dispatch({
        type: "BASICINFODATA",
        payload: res?.data?.getBasicInfoData,
      });
    } else {
      Swal.fire(res?.message, "", "error");
    }
  });
}

export function getPanchayatSarpanchData(sec_id) {
  CommonAxiosGet(`panchayatProfile/getPanchayatSarpanchData/${sec_id}`).then(
    (res) => {
      store.dispatch({
        type: "PANCHAYATSARPANCHDATA",
        payload: res?.data?.getPanchayatSarpanchData,
      });
    }
  );
}

export function getPanchayatSecretariatData(sec_id) {
  CommonAxiosGet(`panchayatProfile/getPanchayatSecretarialData/${sec_id}`).then(
    (res) => {
      store.dispatch({
        type: "PANCHAYATSECDATA",
        payload: res?.data?.getPanchayatSecretariatData,
      });
    }
  );
}

export function getWardMemberData(sec_id) {
  CommonAxiosGet(`panchayatProfile/getWardMemberList/${sec_id}`).then((res) => {
    store.dispatch({
      type: "WARDMEMBERDATA",
      payload: res?.data?.getWardMemberData,
    });
  });
}

export function getPanchayatSecretariatList(sec_id) {
  CommonAxiosGet(`panchayatProfile/getPanchayatSecData/${sec_id}`).then(
    (res) => {
      store.dispatch({
        type: "PANCHAYATSECRETARIATDATA",
        payload: res?.data?.getPanchayatSecData,
      });
    }
  );
}

export function getinfrastructureList(sec_id) {
  CommonAxiosGet(`panchayatProfile/getEduInsData/${sec_id}`).then((res) => {
    store.dispatch({
      type: "INFRASTRUCTUREFACLIST",
      payload: res?.data?.getEduInfData,
    });
  });
}

export function getHealthCareList(sec_id) {
  CommonAxiosGet(`panchayatProfile/getHealthData/${sec_id}`).then((res) => {
    store.dispatch({
      type: "HEALTHCARELIST",
      payload: res?.data?.getHealthData,
    });
  });
}

export const getActiveInActive = async (pan_map_id) => {
  let payload = {
    p_panchyatsecretary_mapid: pan_map_id,
    p_user_id: "apcfssadmin",
  };
  try {
    const res = await axios.post(
      config.url.API_URL + `mappingform/inactive-cfmsid`,
      payload
    );
    if (res?.data?.scode == "01") {
      Swal.fire(res.data?.sdesc, "", "success");
    } else if (res?.data?.scode == "02") {
      Swal.fire(res.data?.sdesc, "", "success");
    } else if (res?.data?.scode == "03") {
      Swal.fire(res.data?.sdesc, "", "success");
    }
  } catch (error) {
    Swal.fire({
      title: "An error occurred while fetching data",
      icon: "error",
    });
  }
};

export function allowNumbersOnly(e) {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;
  var value = Number(e.target.value + e.key) || 0;
  if (keyCode >= 48 && keyCode <= 57) {
    return isValidNumber(value);
  } else {
    e.preventDefault();
  }
  return false;
}
const isValidNumber = (number) => {
  return 1 <= number && number <= 10;
};

export function allowAlphabetAndSpacesOnly(e) {
  var keyCode = e.charCode;
  var value = Number(e.target.value + e.key) || 0;
  if (
    !(keyCode >= 65 && keyCode <= 123) &&
    keyCode !== 32 &&
    keyCode !== 0 &&
    keyCode !== 40 &&
    keyCode !== 41
  ) {
    e.preventDefault();
  } else {
    return value;
  }
  return false;
}

// export function allowNumbersDecimalOnly(e) {
//     var keyCode = e.keyCode || e.charCode || e.which;
//     var value = e.target.value;

//     // Allow navigation keys
//     if (keyCode === 8 || keyCode === 46 || keyCode === 37 || keyCode === 39 || keyCode === 9) {
//         return true;
//     }

//     // Allow numbers and decimal point
//     if ((keyCode >= 48 && keyCode <= 57) || keyCode === 190) {
//         var newValue = value + e.key;

//         // Validate if it's a valid number with up to two decimal places
//         return isValidNumberDecimal(newValue);
//     } else {
//         e.preventDefault();
//         return false;
//     }
// }

export function allowNumbersDecimalOnly(e) {
  var keyCode = e.keyCode || e.charCode || e.which;
  var value = e.target.value;

  // Allow navigation keys (backspace, delete, arrow keys, tab)
  if (
    keyCode === 8 ||
    keyCode === 46 ||
    keyCode === 37 ||
    keyCode === 39 ||
    keyCode === 9
  ) {
    return true;
  }


  // Allow numbers and decimal point
  if ((keyCode >= 48 && keyCode <= 57) || keyCode === 190) {
    var newValue = value + e.key;

    // If the key is a decimal point, check if there is already a decimal point
    if (keyCode === 190) {
      if (value.indexOf(".") !== -1) {
        // Prevent adding another decimal point
        e.preventDefault();
        return false;
      }
    }

    // Validate if it's a valid number with up to two decimal places
    if (isValidNumberDecimal(newValue)) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  } else {
    e.preventDefault();
    return false;
  }
}


export function allowNumbersDecimalCommaOnly(e) {
  var keyCode = e.keyCode || e.charCode || e.which;
  var value = e.target.value;

  // Allow navigation keys (backspace, delete, arrow keys, tab)
  if ([8, 46, 37, 39, 9].includes(keyCode)) {
    return true;
  }

  // Allow comma (,) anywhere without breaking validation
  if (keyCode === 44) {
    return true;
  }

  // Allow numbers (0–9) and decimal point (.)
  if ((keyCode >= 48 && keyCode <= 57) || keyCode === 190) {
    // Build new value but ignore commas when validating
    var newValue = (value + e.key).replace(/,/g, "");

    // If the key is a decimal point, check if there is already a decimal point
    if (keyCode === 190 && value.indexOf(".") !== -1) {
      e.preventDefault();
      return false;
    }

    // Validate if it's a valid number with up to two decimal places
    if (isValidNumberDecimal(newValue)) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  }

  // Block everything else
  e.preventDefault();
  return false;
}


export function allowNumbersSingleDecimalOnly(e) {
  var keyCode = e.keyCode || e.charCode || e.which;
  var value = e.target.value;

  // Allow navigation keys (backspace, delete, arrow keys, tab)
  if (
    keyCode === 8 || // Backspace
    keyCode === 46 || // Delete
    keyCode === 37 || // Left arrow
    keyCode === 39 || // Right arrow
    keyCode === 9 // Tab

  ) {
    return true;
  }

  // Allow numbers (0-9) and decimal point (.)
  if (
    (keyCode >= 48 && keyCode <= 57) || // Numbers 0-9
    (keyCode >= 96 && keyCode <= 105) || // Numpad numbers 0-9
    keyCode === 190 || // Period (.)
    keyCode === 110 // Numpad period (.)
  ) {
    // If the key is a decimal point, check if there's already one
    if ((keyCode === 190 || keyCode === 110) && value.includes(".")) {
      e.preventDefault();
      return false;
    }
    return true;
  }

  e.preventDefault();
  return false;
}


function isValidNumberDecimal(value) {
  // Regular expression to validate numbers with up to 2 decimal places
  var regex = /^\d+(\.\d{0,2})?$/;
  return regex.test(value);
}

export function allowAlphabetsAndNumbersOnly(e) {
  var keyCode = e.charCode;

  if (
    !(keyCode >= 48 && keyCode <= 57) && // Numbers (0-9)
    !(keyCode >= 65 && keyCode <= 90) && // Uppercase Alphabets (A-Z)
    !(keyCode >= 97 && keyCode <= 122) // Lowercase Alphabets (a-z)
  ) {
    e.preventDefault();
  }
}

export function allowAlphabetAndSpacesComaOnly(e) {
  var keyCode = e.charCode;
  var value = Number(e.target.value + e.key) || 0;

  if (
    !(keyCode >= 65 && keyCode <= 123) && // Allow letters (A-Z, a-z)
    keyCode !== 32 && // Allow space
    keyCode !== 44 && // Allow comma
    keyCode !== 0 && // Allow keypresses like backspace, delete, etc.
    keyCode !== 40 && // Allow left parenthesis
    keyCode !== 41 // Allow right parenthesis
  ) {
    e.preventDefault(); // Prevent any invalid characters from being entered
  } else {
    return value; // Allow valid characters
  }
  return false;
}

export function allowAlphabetsNumbersSpacesAndSpecialChars(e) {
  var keyCode = e.charCode;

  // Check if the key pressed is a number, an alphabet character, a space, or one of the allowed special characters
  if (
    !(keyCode >= 48 && keyCode <= 57) && // Numbers (0-9)
    !(keyCode >= 65 && keyCode <= 90) && // Uppercase Alphabets (A-Z)
    !(keyCode >= 97 && keyCode <= 122) && // Lowercase Alphabets (a-z)
    keyCode !== 32 && // Space
    keyCode !== 44 && // Comma (,)
    keyCode !== 45 && // Hyphen (-)
    keyCode !== 47 // Slash (/)
  ) {
    e.preventDefault();
  }
}

export function allowAlphabetsNumbersAndSpacesOnly(e) {
  var keyCode = e.charCode;

  // Check if the key pressed is a number, an alphabet character, or a space
  if (
    !(keyCode >= 48 && keyCode <= 57) && // Numbers (0-9)
    !(keyCode >= 65 && keyCode <= 90) && // Uppercase Alphabets (A-Z)
    !(keyCode >= 97 && keyCode <= 122) && // Lowercase Alphabets (a-z)
    keyCode !== 32 // Space
  ) {
    e.preventDefault();
  }
}

export function allowAlphabetsNumbersAndWithoutSpacesOnly(e) {
  var keyCode = e.charCode;

  // Check if the key pressed is a number, an alphabet character, or a space
  if (
    !(keyCode >= 48 && keyCode <= 57) && // Numbers (0-9)
    !(keyCode >= 65 && keyCode <= 90) && // Uppercase Alphabets (A-Z)
    !(keyCode >= 97 && keyCode <= 122)// && // Lowercase Alphabets (a-z)
    // keyCode !== 32 // Space
  ) {
    e.preventDefault();
  }
}



export function allowEmailNumbersOnly(e) {
  var keyCode = e.keyCode === 0 ? e.charCode : e.keyCode;

  // Allow numbers (0-9), alphabets (A-Z, a-z), '@', '.', and '_'
  if (
    (keyCode >= 48 && keyCode <= 57) || // Numbers 0-9
    (keyCode >= 65 && keyCode <= 90) || // Uppercase A-Z
    (keyCode >= 97 && keyCode <= 122) || // Lowercase a-z
    keyCode === 64 || // @ symbol
    keyCode === 46 || // . (dot)
    keyCode === 95 // _ (underscore)
  ) {
    return true; // Allow these keys
  } else {
    e.preventDefault(); // Block all other characters
  }
}

export function allowAlphabetsNumbersSpace(e) {
  var key = e.key;

  // Allow numbers (0-9), alphabets (A-Z, a-z), and space
  if (
    !(key >= "0" && key <= "9") && // Numbers (0-9)
    !(key >= "A" && key <= "Z") && // Uppercase Alphabets (A-Z)
    !(key >= "a" && key <= "z") && // Lowercase Alphabets (a-z)
    key !== " " // Space
  ) {
    e.preventDefault();
  }
}

export function getOutsidePopulatedDetails(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsidePopulatedDetails/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "POPULATEDDETAILS",
        payload: res?.data?.getPopulatedDetails,
      });
    });
}

export function getOutsideRevenueVillageData(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsideVillages/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "REVENUEVILLAGEDATA",
        payload: res?.data?.villageListVerify,
      });
    });
}

export function getOutsideHabitationData(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsideHabitation/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "HABITATIONDATA",
        payload: res?.data?.habitationList,
      });
    });
}

export function getOutsideBaiscInformationData(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsideBasicInfo/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "BASICINFODATA",
        payload: res?.data?.getBasicInfoData,
      });
    });
}

export function getOutsidePanchayatSarpanchData(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsidePanchayatSarpanchData/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "PANCHAYATSARPANCHDATA",
        payload: res?.data?.getPanchayatSarpanchData,
      });
    });
}

export function getOutsidePanchayatSecretariatData(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsidePanchayatSecretarialData/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "PANCHAYATSECDATA",
        payload: res?.data?.getPanchayatSecretariatData,
      });
    });
}

export function getOutsideWardMemberData(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsideWardMemberList/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "WARDMEMBERDATA",
        payload: res?.data?.getWardMemberData,
      });
    });
}

export function getOutsidePanchayatSecretariatList(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsidePanchayatSecData/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "PANCHAYATSECRETARIATDATA",
        payload: res?.data?.getPanchayatSecData,
      });
    });
}

export function getOutsideinfrastructureList(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsideEduInsData/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "INFRASTRUCTUREFACLIST",
        payload: res?.data?.getEduInfData,
      });
    });
}

export function getOutsideHealthCareList(sec_id) {
  axios
    .get(
      config.url.API_URL +
      `outside/panchayatProfile/getOutsideHealthData/${sec_id}`
    )
    .then((res) => {
      store.dispatch({
        type: "HEALTHCARELIST",
        payload: res?.data?.getHealthData,
      });
    });
}

export function getHighestYear(academicyearmst) {
  const highestYear = academicyearmst.reduce((max, current) => {
    return current.acdyr > max.acdyr ? current : max;
  });

  store.dispatch({ type: "HIGHESTACYEAR", payload: highestYear });
}

export const OnlyNumbers = /^\d+$/;
export const OnlyDecimalNumbers = /^\d+(\.\d+)?$/;
export const OnlyAlphabates = /^[A-Za-z\s]+$/;
export const OnlyEmailsOnly =
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const OnlyNumbersAlphabates = /^[A-Za-z0-9]+$/;
export const OnlyNumbersAlphabatesSpaces = /^[A-Za-z0-9\s]+$/;
export const DateValidation =
  /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
export const MOBILE_VALIDATION = /^[6-9]{1}[0-9]{9}$/;
export const AddressofProvider = /^[A-Za-z0-9\-\/ ]+$/;
export const spaces = /^(?! )[A-Za-z0-9 ]+(?<! )$/;


export const currentdate = new Date().toLocaleDateString();

export function getRoleLoginBaseDistrict(role) {
  CommonAxiosGet(`/districtdesc/${role}`).then((res) => {
    if (res?.data?.scode == "01") {
      store.dispatch({ type: "ROLELOGINDISTRICTS", payload: res?.data?.sdesc });
    } else if (res?.data?.scode == "02") {
      store.dispatch({ type: "ROLELOGINDISTRICTS", payload: "" });
    }
  });
}
export function getLoginRoleCfmssMandalList(district_id, role) {
  CommonAxiosGet(`getloginrolecfmsmandallist/${district_id}/${role}`).then(
    (res) => {
      store.dispatch({ type: "ROLECFMSMANDALLIST", payload: res?.data?.data });
    }
  );
}

export function getloginWiseRevenueDivisions(role, cfmsid) {
  if (role && cfmsid) {
    CommonAxiosGet('getloginWiseRevenueDivisions/' + role + "/" + cfmsid).then((res) => {
      store.dispatch({ type: "ROLEREVENUEDIVISIONS", payload: res?.data?.data });
    })
  }
}


export function getloginWiseRevenueDivisionsWiseMandalsList(revenueId) {
  if (revenueId) {
    CommonAxiosGet('getloginWiseRevenueDivisionsWiseMandals/' + revenueId).then((res) => {
      store.dispatch({ type: "ROLEREVENUEDIVISIONSMANDAL", payload: res?.data?.data });
    })
  }
}


export function getOutsideSecretariatDetailsRevenue(mandal_id) {
  if (mandal_id) {
    axios.get(config.url.API_URL + `loginpayment/secretariats/${mandal_id}`).then((res) => {
      if (res.data.scode === "01") {
        store.dispatch({
          type: "OUTSIDESECRETARIAT", payload: res?.data?.data,
        });
      }
    });
  }
}


export function getOutsideSecretariatDetailsRevenueOthers(mandal_id) {
  if (mandal_id) {
  CommonAxiosGet(`panchayatdetails/${mandal_id}`).then((res) => {
      if (res.data.scode === "01") {
        store.dispatch({
          type: "OUTSIDESECRETARIAT", payload: res?.data?.data,
        });
      }
    });
  }
}

export function getTargetnonTaxDetails(sec_id, type) {
  CommonAxiosGet(`gettargetdemandnontax/${sec_id}/${type}`).then((res) => {
    store.dispatch({
      type: "NONTAXTARGETDETAILS",
      payload: res?.data?.data[0]?.total_demand,
    });
  });
}

export function PaymentModeMaster() {
  CommonAxiosGet(`payment/modemaster`).then((res) => {
    store.dispatch({ type: "MODEMASTER", payload: res?.data?.data });
  });
}

export function getPaymentCategory() {
  CommonAxiosGet(`getpaymentcategory`).then((res) => {
    store.dispatch({ type: "PAYMENTCATEGOREY", payload: res?.data?.data });
  });
}

export function getCurrentDate() {
  const date = new Date();

  // Get the year, month, and day
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 because getMonth() is 0-based
  const day = String(date.getDate()).padStart(2, "0"); // padStart ensures two-digit day/month

  const formattedDate = `${year}-${month}-${day}`;

  store.dispatch({ type: "CURRENTDATE", payload: formattedDate });
}

export function districtmast() {
  CommonAxiosGet("/getdistrictmast").then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({ type: "DISTRICTMASTER", payload: res?.data?.getdistrictmast })
      // console.log("DISTRICTMASTER : ", res?.data?.getdistrictmast)
    }
  })
}

export function mandalmast(value) {
  // alert("11")
  // console.log("222",value+"/getmandalmast")
  CommonAxiosGet(value + "/getmandalmast").then((res) => {
    if (res.data.scode === "01") {
      // console.log('resdata',res?.data)
      store.dispatch({ type: "MANDALMASTER", payload: res?.data?.getmandalmast })
    }
  })
}
export function villagemast(distid, mandalid) {
  // alert("VillageMaster");
  CommonAxiosGet(distid + "/" + mandalid + "/getvillagemast").then((res) => {
    if (res.data.scode === "01") {
      // console.log('resdata',res?.data)
      store.dispatch({ type: "VILLAGEMASTER", payload: res?.data?.getvillagemast })
    }
  })
}


export function modulemast() {
  CommonAxiosGet("/getmodulemast").then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({
        type: "MODULEMASTER",
        payload: res?.data?.getmodulemast,
      });
    } else {
      store.dispatch({ type: "MODULEMASTER", payload: [] });
    }
  });
}

export function submodulemast(moduleid) {
  console.log("ModuleId : ", moduleid);
  if (moduleid === "" || moduleid === null) {
    Swal.fire({
      title:
        "Plz... Select Proper Information in Module Details Shown in Drop Down",
      position: "center",
      icon: "info",
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: "Ok",
      denyButtonText: "Cancel",
    });
  } else {
    CommonAxiosGet("/getsubmodulemast/" + moduleid).then((res) => {
      if (res.data.scode === "01") {
        store.dispatch({
          type: "SUBMODULEMASTER",
          payload: res?.data?.getsubmodulemast,
        });
      } else {
        store.dispatch({ type: "SUBMODULEMASTER", payload: [] });
      }
    });
  }
}

export function innersubmodulemast(submoduleid) {
  console.log("Sub-ModuleId : ", submoduleid);
  if (submoduleid === "" || submoduleid === null) {
    Swal.fire({
      title:
        "Plz... Select Proper Information in Sub-Module Details Shown in Drop Down",
      position: "center",
      icon: "info",
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: "Ok",
      denyButtonText: "Cancel",
    });
  } else {
    CommonAxiosGet("/getinsubmodulemast/" + submoduleid).then((res) => {
      if (res.data.scode === "01") {
        store.dispatch({
          type: "INNERSUBMODULEMASTER",
          payload: res?.data?.getinsubmodulemast,
        });
      } else {
        store.dispatch({ type: "INNERSUBMODULEMASTER", payload: [] });
      }
    });
  }
}

export function childinnersubmodulemast(innersubmoduleid) {
  console.log("inner-Sub-ModuleId : ", innersubmoduleid);
  if (innersubmoduleid === "" || innersubmoduleid === null) {
    Swal.fire({
      title:
        "Plz... Select Proper Information in Inner-Sub-Module Details Shown in Drop Down",
      position: "center",
      icon: "info",
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: "Ok",
      denyButtonText: "Cancel",
    });
  } else {
    CommonAxiosGet("/getchildinsubmodulemast/" + innersubmoduleid).then(
      (res) => {
        if (res.data.scode === "01") {
          store.dispatch({
            type: "CHILDINNERSUBMODULEMASTER",
            payload: res?.data?.getchildinsubmodulemast,
          });
        } else {
          store.dispatch({ type: "CHILDINNERSUBMODULEMASTER", payload: [] });
        }
      }
    );
  }
}
export function rolemast() {
  CommonAxiosGet("/getrolemast").then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({ type: "ROLEMASTER", payload: res?.data?.getrolemast });
    } else {
      store.dispatch({ type: "ROLEMASTER", payload: [] });
    }
  });
}

export function childinnersubmodulesrvmast(
  moduleid,
  submoduleid,
  innersubmoduleid,
  chinnersubmoduleid
) {
  console.log(
    "Child Inner Sub Module Service Master",
    moduleid,
    submoduleid,
    innersubmoduleid,
    chinnersubmoduleid
  );
  if (chinnersubmoduleid === "" || chinnersubmoduleid === null) {
    Swal.fire({
      title:
        "Plz... Select Proper Information in Child Inner-Sub-Module Details Shown in Drop Down",
      position: "center",
      icon: "info",
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: "Ok",
      denyButtonText: "Cancel",
    });
  } else {
    CommonAxiosGet(
      "/getchinsubmodulesrvmast/" +
      moduleid +
      "/" +
      submoduleid +
      "/" +
      innersubmoduleid +
      "/" +
      chinnersubmoduleid
    ).then((res) => {
      console.log("CHILDINNERSUBMODULEsrvMASTER", res?.data);
      if (res.data.scode === "01") {
        store.dispatch({
          type: "CHILDINNERSUBMODULEsrvMASTER",
          payload: res?.data?.getchinsubmodulesrvmast,
        });
      } else {
        store.dispatch({ type: "CHILDINNERSUBMODULEsrvMASTER", payload: [] });
        Swal.fire(res.sdesc);
      }
    });
  }
}




export function rolemaster() {
  CommonAxiosGet("/getrolemasterdata").then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({
        type: "ROLEMASTER1",
        payload: res?.data?.rolemasterdetails,
      });
    }
  });
}

//outside Apis
export function getOutsideDistrict() {
  axios.get(config.url.API_URL + "loginpayment/districts").then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({
        type: "OUTSIDEDISTRICT", payload: res?.data?.data,
      });
    }
  });
}



export function getOutsideMandals(district_id) {
  axios.get(config.url.API_URL + `loginpayment/mandals/${district_id}`).then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({
        type: "OUTSIDEMANDALS", payload: res?.data?.data,
      });
    }
  });
}


export function getOutsideSecretariatDetails(district_id, mandal_id) {
  axios.get(config.url.API_URL + `loginpayment/secretariats/${district_id}/${mandal_id}`).then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({
        type: "OUTSIDESECRETARIAT", payload: res?.data?.data,
      });
    }
  });
}


export function getOutsideVillages(secretariat_id) {
  axios.get(config.url.API_URL + `loginpayment/villages/${secretariat_id}`).then((res) => {
    if (res.data.scode === "01") {
      store.dispatch({
        type: "OUTSIDEVILLAGES", payload: res?.data?.data,
      });
    }
  });
}

export function roleservicemapping() {
  CommonAxiosGet(`getroleservicemap`).then((res) => {
    store.dispatch({
      type: "ROLESERVICEMAP",
      payload: res?.data?.roleservicemap,
    });
  });
}

export function treasurymaster() {
  CommonAxiosGet(`gettreasurymaster`).then((res) => {
    store.dispatch({
      type: "TRESURYMASTER",
      payload: res?.data?.treasurymaster,
    });
  });
}


export function PrntMapiDetailsOutside() {
  axios.get(config.url.API_URL + "loginpayment/property_reg_details_outside").then((res) => {
    if (res?.data?.scode == "01") {
      store.dispatch({ type: 'NONTAXPROPERTYDETAILS', payload: res?.data });
    }
  })
}

export function getfinancialyear() {
  CommonAxiosGet(`getacademicyearservicedata`).then((res) => {
    store.dispatch({
      type: "FINANCIALYEAR",
      payload: res?.data?.data,
    });
  });
}

export function getfinYearSingle() {
  CommonAxiosGet(`/fin-Year`).then((res) => {
    store.dispatch({
      type: "FINYEAR",
      payload: res?.data?.sdesc,
    });
  });
}





export function getHabitationMaster(sec_id) {
  CommonAxiosGet(`citizen-service/getHabitationDetails/secId/` + sec_id).then((res) => {
    store.dispatch({ type: "HABITATIONRES", payload: res?.data?.Habitation });
  });
}

export function PanchayatSecretariat(sec_id) {
  CommonAxiosGet(`getpanchayatsecmaster/` + sec_id).then((res) => {
    store.dispatch({ type: "PANSECRES", payload: res?.data?.data });
  });
}


function getTimeData(rawTime) {
  const date = new Date(rawTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}`;
  store.dispatch({ type: "REFRESHTIMEVIEWS", payload: formattedTime });
}


export function getRefreshTimeViews(flag) {
  CommonAxiosGet("getviewsrefreshtime/" + flag).then((res) => {
    if (res?.data?.scode == "01") {
      const rawTime = res?.data?.data[0]?.mat_viewrefreshed_time;
      getTimeData(rawTime)
    }
  })
}


export function getRefreshTimeData() {
  CommonAxiosGet("getRefreshTime").then((res) => {
    if (res?.data?.scode === "01") {
      const rawTime = res?.data?.data[0]?.current_time;
      getTimeData(rawTime)
    }
  });
}


export function departmentMaster(cfms_id) {
  CommonAxiosGet(`detailedHead/${cfms_id}`).then((res) => {
    if (res?.data?.scode == "01") {
      console.log("detailed", res?.data)
      const data = res.data.data || [];
      store.dispatch({ type: "DETAILEDID", payload: data });
      store.dispatch({ type: "DRAWLMODEMAST", payload: res.data?.drawlModeMst });

    }
  })
}

export function subdetailHead(cfms_id, detailedHeadd) {
  CommonAxiosGet(`subdetailedHead/${cfms_id}/${detailedHeadd}`).then((res) => {
    if (res?.data?.scode == "01") {
      store.dispatch({ type: "SUBDETAILEDID", payload: res?.data?.data });
    }
  })
}


export const ItemDetails = async (cfms_id, detailedHead, subdetailedHead) => {
  try {
    const response = await CommonAxiosGet(`itemdetails/${cfms_id}/${detailedHead}/${subdetailedHead}`);
    if (response?.data?.scode === "01") {
      store.dispatch({ type: "ITEMDETAILS", payload: response.data?.data });
    } else {

    }
  } catch (error) {
    console.error("Error fetching item details:", error);
  }
};

export const UnitofMesurement = async (cfms_id) => {
  try {
    const response = await CommonAxiosGet(`unit-of-measurement/${cfms_id}`);
    if (response?.data?.scode === "01") {
      store.dispatch({ type: "MEASUREMENTUNIT", payload: response.data?.data });
    } else {

    }
  } catch (error) {
    console.error("Error fetching item details:", error);
  }
};

export const UnitofMesurementwithPriceLimit = async (
  secretariatId,
  itemDetailsId
) => {
  try {
    const response = await CommonAxiosGet(
      `unit-of-measurement-pricelimit/${secretariatId}/${itemDetailsId}`
    );

    if (response?.data?.scode === "01") {
      store.dispatch({
        type: "MEASUREMENTUNITWITHPRICELIMIT",
        payload: {
          itemDetailsId,
          data: response.data.data || []
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
};



//master data apis
export function getSectorMasterList() {
  CommonAxiosGet(`getsectormasterlist`).then((res) => {
    if (res?.data?.scode === "01") {
      store.dispatch({
        type: "SECTORLIST",
        payload: res?.data?.data,
      });
    }
    else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
      Swal.fire(res?.data?.message, "", "info")
    }
  });
}

export function getSectorMasterListOthers() {
  CommonAxiosGet(`getsectormasterlistothers`).then((res) => {
    if (res?.data?.scode === "01") {
      store.dispatch({
        type: "SECTORLIST",
        payload: res?.data?.data,
      });
    }
    else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
      Swal.fire(res?.data?.message, "", "info")
    }
  });
}

export function getDesignationList(sector_id) {
  if (sector_id) {
    CommonAxiosGet(`getdesignationmasterlist/` + sector_id).then((res) => {
      if (res?.data?.scode === "01") {
        store.dispatch({
          type: "DESIGNATIONLIST",
          payload: res?.data?.data,
        });
      }
      else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
        Swal.fire(res?.data?.message, "", "info")
      }
    });
  }
}


export function getDesignationListOthers(sector_id) {
  if (sector_id) {
    CommonAxiosGet(`getdesignationmasterlistOthers/` + sector_id).then((res) => {
      if (res?.data?.scode === "01") {
        store.dispatch({
          type: "DESIGNATIONLIST",
          payload: res?.data?.data,
        });
      }
      else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
        Swal.fire(res?.data?.message, "", "info")
      }
    });
  }
}


export function getCategoryofPostList(sector_id, designation) {
  if (sector_id && designation) {
    CommonAxiosGet(`getPostCatgoryMst/` + sector_id + "/" + designation).then((res) => {
      if (res?.data?.scode === "01") {
        store.dispatch({
          type: "CATEGORYLIST",
          payload: res?.data?.data,
        });
      }
      else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
        Swal.fire(res?.data?.message, "", "info")
      }
    });
  }
}


export function getCategoryofPostListOthers(sector_id, designation) {
  if (sector_id && designation) {
    CommonAxiosGet(`getPostCatgoryMstOthers/` + sector_id + "/" + designation).then((res) => {
      if (res?.data?.scode === "01") {
        store.dispatch({
          type: "CATEGORYLIST",
          payload: res?.data?.data,
        });
      }
      else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
        Swal.fire(res?.data?.message, "", "info")
      }
    });
  }
}

export function getNatureofWorkList(designation, sector_id, post) {
  if (designation && sector_id && post) {
    CommonAxiosGet(`getWosrknaturemst/` + designation + "/" + sector_id + "/" + post).then((res) => {
      if (res?.data?.scode === "01") {
        store.dispatch({
          type: "NATURELIST",
          payload: res?.data?.data,
        });
      }
      else if (res?.data?.scode === "02" || res?.data?.scode === "03") {
        Swal.fire(res?.data?.message, "", "info")
      }
    });
  }
}

//vendor details api

export function getVendorDetails(vendorcode) {
  if (vendorcode) {
    CommonAxiosGet(`expenditureVendor/` + vendorcode).then((res) => {
      store.dispatch({
        type: "VENDERDETAILS",
        payload: res?.data?.ROW,
      });

    });
  }

}



export function getAuctionsTargetDetails() {
  CommonAxiosGet(`target/auction-submitdata`).then((res) => {
    console.log("resdata", res?.data?.data);
    store.dispatch({
      type: "AUCTIONSTARGET",
      payload: res?.data?.data,
    });
  });
}



export function getTapTargetDetails() {
  CommonAxiosGet(`tapfee-targetdetails`).then((res) => {
    store.dispatch({
      type: "TAPTARGET",
      payload: res?.data?.tapfeetargetDetails,
    });
  });
}




export function getMandalsDistrictNMR(roleId, cfmsId) {
  CommonAxiosGet(`getDPOMandalsNMR/${roleId}/${cfmsId}`).then((res) => {
    console.log("readata111", res?.data);
    store.dispatch({
      type: "GETDISMANNMR",
      payload: res?.data?.data,
    });
  });
}


export function getMandalsDistrictNMROthers(roleId, cfmsId) {
  CommonAxiosGet(`mandaldetails/${cfmsId}/${roleId}`).then((res) => {
    console.log("readata111", res?.data);
    store.dispatch({
      type: "GETDISMANNMR",
      payload: res?.data?.data,
    });
  });
}




export function getPostNmr() {
  CommonAxiosGet(`getNatureOfPurposeWork`).then((res) => {
    console.log("readata111", res?.data);
    store.dispatch({
      type: "PURPOSENMR",
      payload: res?.data?.data,
    });
  });
}



export function getAadhaarValidationDataNmr(aadhaar_no) {
  CommonAxiosGet(`nmr-aadharCheck/${aadhaar_no}`).then((res) => {
    if (res?.data?.scode === "01") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANMR",
        payload: res?.data?.data,
      });
    }
    else if (res?.data?.scode === "02") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANMR",
        payload: "02",
      });
    }
  });
}




export function getAadhaarValidationDataNonNmr(aadhaar_no, secretariat_id) {
  CommonAxiosGet(`non-nmr-aadharCheck/${aadhaar_no}/${secretariat_id}`).then((res) => {

    if (res?.data?.scode === "01") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANONNMR",
        payload: res?.data?.data,
      });
    }
    else if (res?.data?.scode === "02") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANONNMR",
        payload: "02",
      });
    }
  });
}




export function getAadhaarValidationDataNmrNew(aadhaar_no) {
  CommonAxiosGet(`new-aadharCheck/${aadhaar_no}`).then((res) => {
    if (res?.data?.scode === "01") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANMR",
        payload: res?.data?.data,
      });
    }
    else if (res?.data?.scode === "02") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANMR",
        payload: "02",
      });
    }
  });
}





export function EditgetAadhaarValidationDataNmrNew(aadhaar_no, vsdId) {
  CommonAxiosGet(`edit-new-aadharCheck/${aadhaar_no}/${vsdId}`).then((res) => {
    if (res?.data?.scode === "01") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANMR",
        payload: res?.data?.data,
      });
    }
    else if (res?.data?.scode === "02") {
      store.dispatch({
        type: "AADHAARVALIDATIONDATANMR",
        payload: "02",
      });
    }
  });
}

export function departmentMasterMiscellaneous(cfms_id) {
  CommonAxiosGet(`detailedHead/miscellaneous/${cfms_id}`).then((res) => {
    if (res?.data?.scode == "01") {
      console.log("detailed", res?.data)
      const data = res.data?.data || [];
      store.dispatch({ type: "DETAILEDIDMISCLLENAOUS", payload: data });
      store.dispatch({ type: "DRAWLMODEMISCLLENAOUS", payload: res.data?.drawlModeMst });
    } else {
      store.dispatch({ type: "DETAILEDIDMISCLLENAOUS", payload: [] });
      store.dispatch({ type: "DRAWLMODEMISCLLENAOUS", payload: [] });
    }
  })
}

export function subdetailHeadMiscellaneous(cfms_id, detailedHeadd) {
  CommonAxiosGet(`subdetailedHead/miscellaneous/${cfms_id}/${detailedHeadd}`).then((res) => {
    if (res?.data?.scode == "01") {
      store.dispatch({ type: "SUBDETAILEDIDMISCLLENAOUS", payload: res?.data?.data });
    } else {
      store.dispatch({ type: "SUBDETAILEDIDMISCLLENAOUS", payload: [] });
    }
  })
}

export const ItemDetailsMiscellaneous = async (cfms_id, detailedHead, subdetailedHead) => {
  try {
    const response = await CommonAxiosGet(`itemdetails/miscellaneous/${cfms_id}/${detailedHead}/${subdetailedHead}`);
    if (response?.data?.scode === "01") {
      store.dispatch({ type: "ITEMDESCRIPTION", payload: response.data?.data });
    } else {
      store.dispatch({ type: "ITEMDESCRIPTION", payload: [] });
    }
  } catch (error) {
    console.error("Error fetching item details:", error);
  }
};

export const sectorDetailsMiscellaneous = async (itemdetailsId) => {
  try {
    const response = await CommonAxiosGet(`sectorDetails/${itemdetailsId}`);
    if (response?.data?.scode === "01") {
      store.dispatch({ type: "SECTORDESCRIPTION", payload: response.data?.data });
    } else {
      store.dispatch({ type: "SECTORDESCRIPTION", payload: [] });
    }
  } catch (error) {
    console.error("Error fetching item details:", error);
  }
};



export function getRelationMasterDetails() {
  axios.get(config.url.API_URL+`citizen-service/getRelationMasterData`).then((res) => {
    store.dispatch({type: "RELATIONLIST",payload: res?.data?.data});
  });
}

export function getGrvdetails(grv_id) {
  CommonAxiosGet(`tradeGreivanceApplicantDetils/${grv_id}`).then((res) => {
    store.dispatch({ type: "GRVENCEDETAILS", payload: res?.data?.data });
  });
}

export function getruralurbanmst() {
  CommonAxiosGet(`getRutalUrbanMst`).then((res) => {
    store.dispatch({ type: "RURALURBANMST", payload: res?.data?.data });
  });
}